import React, { useState } from "react";
import "./FAQsPage.css";

const faqs = [
  {
    question: "What products does Vicon offer?",
    answer:
      "Vicon specializes in high-quality spare parts and accessories for home appliances, including air conditioners, refrigerators, washing machines, and more.",
  },
  {
    question: "Are Vicon products compatible with all brands?",
    answer:
      "Our products are designed to be compatible with a wide range of leading appliance brands. Please check the product description or contact us for specific compatibility information.",
  },
  {
    question: "How can I place an order?",
    answer:
      "You can place an order through our website or by contacting our sales team directly via phone or email.",
  },
  {
    question: "Do you offer bulk purchase discounts?",
    answer:
      "Yes, we offer special pricing and discounts for bulk and wholesale purchases. Please contact our sales team for more details.",
  },
  {
    question: "What is your return and replacement policy?",
    answer:
      "We accept returns and replacements for defective or incorrect products within 7 days of delivery. Please refer to our Return Policy page or contact support for assistance.",
  },
  {
    question: "How can I track my order?",
    answer:
      "Once your order is shipped, you will receive a tracking number via email or SMS. You can use this number to track your shipment online.",
  },
  {
    question: "How do I contact customer support?",
    answer:
      "You can reach our customer support team via the Contact Us page, by email at vicondealer@gmail.com, or by phone at +1234567890.",
  },
];

const FAQsPage = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const handleToggle = (idx) => {
    setOpenIndex(openIndex === idx ? null : idx);
  };

  return (
    <div className="faqs-page-bg">
    <div className="faqs-root">
      <h1 className="faqs-title">Frequently Asked Questions</h1>
      <div className="faqs-list">
        {faqs.map((faq, idx) => (
          <div key={idx} className="faq-item">
            <div
              className={`faq-question${openIndex === idx ? " open" : ""}`}
              onClick={() => handleToggle(idx)}
              tabIndex={0}
              onKeyDown={e => (e.key === "Enter" || e.key === " ") && handleToggle(idx)}
              role="button"
              aria-expanded={openIndex === idx}
            >
              {faq.question}
              <span className="faq-toggle">{openIndex === idx ? "−" : "+"}</span>
            </div>
            {openIndex === idx && (
              <div className="faq-answer">{faq.answer}</div>
            )}
          </div>
        ))}
      </div>
    </div>
    </div>
  );
};

export default FAQsPage;